import type { SchemaBuilderFieldType } from "./schema-builder-field-type.type";
import type { SchemaField } from "@/entities/schema";
import type { SchemaBuilderFormContextType } from "@/modules/schema-builder/schema-builder-form";

import { getObjectKeys } from "@/utilities/object";

import {
  SCHEMA_BUILDER_EXCLUDED_FIELD_TYPES,
  SCHEMA_BUILDER_FIELD_TYPE_PICKABLE,
} from "./schema-builder-field-type.constant";

export const getSchemaBuilderFieldType = (
  schema: SchemaField
): SchemaBuilderFieldType => {
  if (schema.type === "input") return schema.inputType;

  return schema.type;
};

export const getSchemaBuilderAllFieldTypes = (
  context: SchemaBuilderFormContextType
) => {
  const fieldTypes = getObjectKeys(SCHEMA_BUILDER_FIELD_TYPE_PICKABLE);
  const excludedTypes = SCHEMA_BUILDER_EXCLUDED_FIELD_TYPES[context];

  if (!excludedTypes?.length) return fieldTypes;

  return fieldTypes.filter((fieldType) => !excludedTypes.includes(fieldType));
};

export const getSchemaBuilderPickableFieldTypes = (
  context: SchemaBuilderFormContextType
) => {
  const fieldTypes = getSchemaBuilderAllFieldTypes(context);

  return fieldTypes.filter(
    (fieldType) => SCHEMA_BUILDER_FIELD_TYPE_PICKABLE[fieldType]
  );
};
